import JSZip from 'jszip'
import { supabase } from '../supabaseClient'

const toCSV = (data) => {
  if (!data || data.length === 0) return '（無資料）'
  const headers = Object.keys(data[0])
  const rows = data.map(row =>
    headers.map(h => {
      const v = row[h]
      if (v === null || v === undefined) return ''
      const str = typeof v === 'object' ? JSON.stringify(v) : String(v)
      return `"${str.replace(/"/g, '""')}"`
    }).join(',')
  )
  return '﻿' + [headers.join(','), ...rows].join('\n')
}

const TABLES = [
  { name: '01_商品清單',    table: 'products' },
  { name: '02_庫存異動記錄', table: 'records' },
  { name: '03_出貨單',      table: 'shipments' },
  { name: '04_生產工單',    table: 'work_orders' },
  { name: '05_生產日誌',    table: 'production_logs' },
  { name: '06_客戶資料',    table: 'customers' },
  { name: '07_供應商',      table: 'suppliers' },
  { name: '08_採購單',      table: 'purchase_orders' },
  { name: '09_採購明細',    table: 'purchase_items' },
  { name: '10_維修記錄',    table: 'maintenance' },
  { name: '11_機台資料',    table: 'machines' },
  { name: '12_出勤記錄',    table: 'attendance' },
  { name: '13_請假記錄',    table: 'leave_requests' },
  { name: '14_任務',        table: 'tasks' },
  { name: '15_員工帳號',    table: 'user_profiles',
    select: 'id,name,employee_id,email,department,phone,position,role,title,created_at' },
]

export const downloadFullBackup = async (companyId, onProgress) => {
  const zip = new JSZip()
  const folder = zip.folder('YPFOPS_備份')

  for (let i = 0; i < TABLES.length; i++) {
    const t = TABLES[i]
    onProgress?.(i + 1, TABLES.length, t.name.replace(/^\d+_/, ''))

    let q = supabase.from(t.table).select(t.select || '*').limit(10000)
    if (companyId) q = q.eq('company_id', companyId)
    const { data } = await q
    folder.file(`${t.name}.csv`, toCSV(data || []))
  }

  // 備份說明
  const date = new Date().toLocaleString('zh-TW', { timeZone: 'Asia/Taipei' })
  folder.file('備份說明.txt',
    `YPFOPS 全局備份\n備份時間：${date}\n\n` +
    `此 ZIP 包含 ${TABLES.length} 個資料表的完整備份。\n` +
    `所有 CSV 檔案均為 UTF-8 編碼，可用 Excel 開啟。\n\n` +
    `如需還原資料，請聯絡系統管理員。`
  )

  const dateStr = new Date().toISOString().slice(0, 10)
  const blob = await zip.generateAsync({ type: 'blob', compression: 'DEFLATE' })
  const a = document.createElement('a')
  a.href = URL.createObjectURL(blob)
  a.download = `YPFOPS_全局備份_${dateStr}.zip`
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(a.href)
}
